import React, { useCallback, useState } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { getCsvSignedUrl } from '../../../services/mail';
import { Spin } from 'antd';

function downloadURI(uri, name) {
  const link = document.createElement('a');
  link.download = name;
  link.href = uri;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}

export default function CSVDownloader({ csv }) {
  const [loading, setLoading] = useState(false);
  const queryClient = useQueryClient();
  const handleDownloadCsvFile = useCallback(async () => {
    if (loading) return;
    setLoading(true);
    try {
      const { signedUrl } = await queryClient.fetchQuery({
        queryKey: ['csvSignedUrl', { id: csv.id }],
        queryFn: () => getCsvSignedUrl(csv.id),
      });
      downloadURI(signedUrl, csv.originalname);
    } catch (e) {
      // Ignore error
    }
    setLoading(false);
  }, [queryClient, csv.id, csv.originalname, loading]);
  return (
    <div className="space-x-2 flex items-center">
      {loading && <Spin size="small" spinning={false} />}
      <a aria-disabled={loading} href="#" onClick={handleDownloadCsvFile}>
        {csv.originalname}
      </a>
    </div>
  );
}
